import { ReactNode } from "react";
import { ThemeSelectorContext } from "@/context";
import { THEMES, ThemeConfig } from "@/constants";
import { isPrime } from "@/utils";

interface ThemeSelectorProviderProps {
  children: ReactNode;
  client?: string;
}

export const ThemeSelectorProvider = ({ children, client }: ThemeSelectorProviderProps) => {
  let theme: ThemeConfig;

  if (!client || !THEMES[client]) {
    theme = isPrime ? THEMES["prime"] : THEMES["default"];
  } else {
    theme = THEMES[client];
  }

  return (
    <ThemeSelectorContext.Provider value={theme}>
      {children}
    </ThemeSelectorContext.Provider>
  );
};
